module.exports = __webpack_public_path__ + "img/promo_code.1b6505e.svg";